import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/react-vertical-timeline-component/style.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/Layout/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/Layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/PageLayouts/fernbehandlung/WieSieFunktioniertLayout.tsx");
